import React from 'react';
import api from '../../services/api';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import history from '../../services/history';
import Swal from 'sweetalert2';
import InputFile from '../inputFile';
import './styles.css';

function AddAnexo({ onSubmit }) {

    let anexos = [];
    let arquivo = '';

    const readFileAsBase64 = (file, fileName) => {
        if(file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (e) => {
                arquivo = e.target.result.split(",")[1];

                var anexo;

                anexo = ({
                    tipoAnexo: fileName,
                    arquivo
                });
                anexos.push(anexo);
                anexo = null;                
            };
        } else {
            arquivo = '';
            
        }
    };

    const salvar = async (e) => {
        e.preventDefault();

        if (anexos.length > 0) {
            try {
                await api.post("/autorizacao-operacao/anexo/list", anexos);
                await Swal.fire("Registro salvo com sucesso!", "", "success");
                history.push("/");
            } catch (error) {
                console.log(error);
                Swal.fire("Ocorreu um erro ao salvar!", "", "error");                
                return;
            }
        }

    };

    return (
        <form onSubmit={salvar} className="anexos">
            <h1 className="title">
				Anexos
			</h1>
            <h2 className="subtitle">
                Anexos exigidos pela Lei nº 7.225, de 14 de Outubro de 2019 
            </h2>

            <InputFile label="Cnpj" nameFile="CNPJ" onChange={readFileAsBase64} requiredFile={true} />
            
            <InputFile label="Contrato Social" nameFile="CONTRATO_SOCIAL" onChange={readFileAsBase64} />
                        
            <InputFile label="Declaração de Intermediação" nameFile="DECLARACAO_INTERMEDIACAO" onChange={readFileAsBase64} />

            <InputFile label="Certidão de Regularidade Federal" nameFile="CERTIDAO_REGULARIDADE_FEDERAL" onChange={readFileAsBase64} />

            <InputFile label="Certidão de Regularidade Estadual" nameFile="CERTIDAO_REGULARIDADE_ESTADUAL" onChange={readFileAsBase64} />

            <InputFile label="Certidão de Regularidade Municipal" nameFile="CERTIDAO_REGULARIDADE_MUNICIPAL" onChange={readFileAsBase64} />

            <InputFile label="Certidão de Regularidade Trabalhista" nameFile="CERTIDAO_REGULARIDADE_TRABALHISTA" onChange={readFileAsBase64} />

            <InputFile label="Certidão de Regularidade FGTS" nameFile="CERTIDAO_REGULARIDADE_FGTS" onChange={readFileAsBase64} />

            <InputFile label="CCM (Empresas com sede em Indaiatuba)" nameFile="CCM_INDAIATUBA" onChange={readFileAsBase64} />

            <div className="field is-grouped">
                <p className="control">
                    <button className="button is-success" type="submit">Salvar</button>
                </p>
                <p className="control">
                    <Link to={`/`} className="button is-light">voltar</Link>
                </p>
            </div>

        </form>
    );

}

export default AddAnexo;